<template>
    <div class="mb-2 d-flex flex-column item" :class="{current: isSelected}" @click="select">
        <div class="item-title d-flex align-items-center">
            <div class="flex-grow-1 contact">
                <span class="filemaker-id" v-if="filemakerId">{{ filemakerId }} </span>
                <span class="contact-first-name" v-if="contactFirstName">{{contactFirstName | trim}},</span>
                <span class="contact-last-name">{{contactLastName | trim}} </span>
                <span class="contact-phone-number">({{contactPhoneNumber}})</span>
            </div>
            <div>
                <el-tooltip v-if="canEditContact" content="Edit Contact" placement="top-start">
                    <span class="btn btn-link btn-link-purple" @click.stop="edit"><i class="fas fa-edit"></i></span>
                </el-tooltip>
            </div>
        </div>
        <div class="message message-body mt-2 pt-2">{{ content }}</div>
    </div>
</template>

<script>
  export default {
    props: {
      item: Object,
      isSelected: Boolean,
    },

    data() {
      return {
        //
      };
    },

    computed: {
      /**
       * @return {object|null}
       */
      contact() {
        return _.get(this.item, 'conversation.contact', null);
      },

      /**
       * @return {string}
       */
      filemakerId() {
        return _.get(this.contact, 'filemaker_id') || '';
      },

      /**
       * @return {string}
       */
      contactPhoneNumber() {
        return _.get(this.contact, 'phone_number') || '';
      },

      /**
       * @return {string}
       */
      contactFirstName() {
        return _.get(this.contact, 'first_name') || '';
      },

      /**
       * @return {string}
       */
      contactLastName() {
        return _.get(this.contact, 'last_name') || '';
      },

      /**
       * @return {string}
       */
      content() {
        return _.get(this, 'item.content', '');
      },

      /**
       * @return {boolean}
       */
      canEditContact() {
        return _.get(this.item, 'contact.canEdit', false);
      },
    },

    methods: {
      /**
       * @emits select
       */
      select() {
        this.$emit('select', this.item);
      },

      /**
       * @emits edit
       */
      edit() {
        this.$emit('edit', {url: this.contact.editUrl});
      },
    },
  }
</script>
